import React from 'react';
import { AuthContext } from '../context/auth';
import { Login, Header, ForgotPassword, ResetPassword, PageNotFound } from '../components';
import PrivateRoute from '../auth/PrivateRoute';
import { Route, Switch, Redirect } from 'react-router-dom';
const Dashboard = React.lazy(() => import('../components/dashboard'));
const Users = React.lazy(()=> import ('../components/users'));
const UserList = React.lazy(()=> import ('../components/UsersList'));
const UserDetails = React.lazy(()=> import ('../components/UserDetails'));
const AdminUsers = React.lazy(() => import ('../components/AdminUsers'))
const AddAdminUsers = React.lazy(()=> import ('../components/AddAdminUsers'));
const AdminEmployers = React.lazy(()=> import ('../components/ManageEmployer'));
const AddEmployer = React.lazy(()=> import ('../components/AddEmployer'));
const UploadEmployer = React.lazy(()=> import ('../components/UploadEmployer'))
const ManageEmployerFilesList = React.lazy(()=> import ('../components/manageEmployerFileList'))
const EmployeeList = React.lazy(()=> import ('../components/ManageEmployee'));
const AddEmployee = React.lazy(()=> import ('../components/AddEmployee'));
const UploadEmployee = React.lazy(() => import ('../components/UploadEmployee'));
const ManageEmployeeFilesList = React.lazy(()=> import ('../components/manageEmployeeFilesList'));
const EarningList = React.lazy(()=> import ('../components/ManageEarnings'));
const UploadEarning = React.lazy(()=> import ('../components/UploadEarning'))
const ManageEarningFileList = React.lazy(()=> import ('../components/manageEarningFilesList'));
const Configuration = React.lazy(()=> import ('../components/Configuration'));
const UsersFeedback = React.lazy(() => import ('../components/users-feedback'));
const PriceManagemant = React.lazy(()=> import ('../components/price-managemant'));
const EditProfile = React.lazy(() => import ('../components/EditProfile'));
const ChangePassword = React.lazy(()=> import ('../components/ChangePassword'))
const ManualChangePassword = React.lazy(()=> import ('../components/ManualChangePassword'))
const ProfileDisbursement = React.lazy(()=> import ('../components/ProfileDisbursement'));
const StatementDetails = React.lazy(( ) => import ('../components/UserDetails/statement-details')) 
const ReportDeduction = React.lazy(( ) => import ('../components/ReportDeduction/report-deduction')) 
const ReportDeductionDetails = React.lazy(( ) => import ('../components/ReportDeductionDetails/report-deduction-details'))
const Help = React.lazy(()=> import ('../components/Help'))


function Navigation() {
  return (
    <AuthContext.Provider>
      <Header />
      <React.Suspense fallback="">
        <Switch>
          <Route path="/login" component={Login} />
          <Redirect exact from="/" to="/login" />
          <Route exact path="/forgot-password" component={ForgotPassword} />
          <Route exact path="/reset-password" component={ResetPassword} />
          <PrivateRoute exact path="/dashboard" component={Dashboard}></PrivateRoute>
          <PrivateRoute exact path="/users" component={Users}></PrivateRoute>
          <PrivateRoute exact path="/users-list/:page" component={UserList}></PrivateRoute>
          <PrivateRoute exact path="/user-details/:id" component={UserDetails}></PrivateRoute>
          <PrivateRoute exact path="/admin-users/:page" component={AdminUsers}></PrivateRoute>
          <PrivateRoute exact path="/add-admin-user" component={AddAdminUsers}></PrivateRoute>
          <PrivateRoute exact path="/edit-admin-user" component={AddAdminUsers}></PrivateRoute>
          <PrivateRoute exact path="/employer-list/:page" component={AdminEmployers}></PrivateRoute>
          <PrivateRoute exact path="/add-employer" component={AddEmployer}></PrivateRoute>
          <PrivateRoute exact path="/edit-employer/:id" component={AddEmployer}></PrivateRoute>
          <PrivateRoute exact path="/upload-employer" component={UploadEmployer}></PrivateRoute>
          <PrivateRoute exact path="/manage-employer-files-list/:page" component={ManageEmployerFilesList}></PrivateRoute>
          <PrivateRoute exact path="/employee-list/:page" component={EmployeeList}></PrivateRoute>
          <PrivateRoute exact path="/add-employee" component={AddEmployee}></PrivateRoute>
          <PrivateRoute exact path="/edit-employee/:id" component={AddEmployee}></PrivateRoute>
          <PrivateRoute exact path="/upload-employee" component={UploadEmployee}></PrivateRoute>
          <PrivateRoute exact path="/manage-employee-files-list/:page" component={ManageEmployeeFilesList}></PrivateRoute>
          <PrivateRoute exact path="/earning-list/:page" component={EarningList}></PrivateRoute>
          <PrivateRoute exact path="/upload-employee-earnings" component={UploadEarning}></PrivateRoute>
          <PrivateRoute exact path="/manage-earning-files-list/:page" component={ManageEarningFileList}></PrivateRoute>
          <PrivateRoute exact path="/configuration" component={Configuration}></PrivateRoute>
          <PrivateRoute exact path="/users-feedback/:page" component={UsersFeedback}></PrivateRoute>
          <PrivateRoute exact path="/price-management" component={PriceManagemant}></PrivateRoute>
          <PrivateRoute exact path="/users-profile" component={EditProfile}></PrivateRoute>
          <PrivateRoute exact path="/user-change-password" component={ManualChangePassword}></PrivateRoute>
          <PrivateRoute exact path="/change-password" component={ChangePassword}></PrivateRoute>
          <PrivateRoute exact path="/profile-disbursement" component={ProfileDisbursement}></PrivateRoute>
          <PrivateRoute exact path="/statement-details/:pay_period_id/:user_id" component={StatementDetails}></PrivateRoute>
          <PrivateRoute exact path="/help" component={Help}></PrivateRoute> 
          <PrivateRoute exact path="/report-deduction" component={ReportDeduction}></PrivateRoute> 
          <PrivateRoute exact path="/report-deduction-details/:employerCode/:payBeginDate/:payEndDate" component={ReportDeductionDetails}></PrivateRoute>
          <Route path="*" component={PageNotFound} />
        </Switch>
      </React.Suspense>
    </AuthContext.Provider>
  )
}

export default Navigation;
